import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=edc2446e&scoped=true&"
import script from "./list-table.vue?vue&type=script&lang=js&"
export * from "./list-table.vue?vue&type=script&lang=js&"
import style0 from "./list-table.vue?vue&type=style&index=0&id=edc2446e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc2446e",
  null
  
)

export default component.exports